import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMail, FiSend, FiLock, FiFileText, FiMapPin } = FiIcons;

const Contact = () => {
  const [formType, setFormType] = useState('general'); // 'general' or 'nda'

  return (
    <div className="pt-24 bg-white min-h-screen">
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            
            {/* Bereich 1: Allgemeiner Kontakt */}
            <motion.div 
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              className="space-y-12"
            >
              <div>
                <span className="text-emerald-600 font-bold uppercase tracking-widest text-xs mb-3 block">Kommunikation</span>
                <h1 className="text-4xl md:text-5xl font-bold text-stone-900 mb-6">Sprechen Sie mit uns</h1>
                <p className="text-lg text-stone-600 leading-relaxed max-w-md">
                  Für allgemeine Anfragen zum Hub in Westerstede oder unseren Anlagenmodulen nutzen Sie bitte dieses Formular.
                </p>
              </div>

              <form className="space-y-6 max-w-md" onSubmit={(e) => e.preventDefault()}>
                <div className="grid gap-6">
                  <div className="space-y-2">
                    <label className="text-xs font-bold uppercase tracking-tighter text-stone-500 ml-1">Name</label>
                    <input type="text" className="w-full bg-stone-50 border border-stone-200 rounded-xl px-4 py-4 focus:border-emerald-500 outline-none transition-all" placeholder="Ihr Name" />
                  </div>
                  <div className="space-y-2">
                    <label className="text-xs font-bold uppercase tracking-tighter text-stone-500 ml-1">Unternehmen</label>
                    <input type="text" className="w-full bg-stone-50 border border-stone-200 rounded-xl px-4 py-4 focus:border-emerald-500 outline-none transition-all" placeholder="Firma GmbH" />
                  </div>
                  <div className="space-y-2">
                    <label className="text-xs font-bold uppercase tracking-tighter text-stone-500 ml-1">E-Mail</label>
                    <input type="email" className="w-full bg-stone-50 border border-stone-200 rounded-xl px-4 py-4 focus:border-emerald-500 outline-none transition-all" placeholder="name@beispiel.de" />
                  </div>
                  <div className="space-y-2">
                    <label className="text-xs font-bold uppercase tracking-tighter text-stone-500 ml-1">Nachricht</label>
                    <textarea rows="4" className="w-full bg-stone-50 border border-stone-200 rounded-xl px-4 py-4 focus:border-emerald-500 outline-none transition-all resize-none" placeholder="Wie können wir Ihnen helfen?"></textarea>
                  </div>
                </div>
                <button className="w-full bg-stone-900 hover:bg-black text-white font-bold py-5 rounded-xl transition-all flex items-center justify-center gap-3 shadow-lg">
                  Anfrage senden
                  <SafeIcon icon={FiSend} className="text-sm" />
                </button>
              </form>
            </motion.div>

            {/* Bereich 2: Technische Dokumentation */}
            <motion.div 
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              className="bg-stone-50 p-10 md:p-16 rounded-[48px] border border-stone-100 relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 p-10 opacity-5">
                <SafeIcon icon={FiLock} className="text-[200px] text-stone-900" />
              </div>

              <div className="relative z-10">
                <div className="w-16 h-16 bg-emerald-600 text-white rounded-2xl flex items-center justify-center mb-8 shadow-xl shadow-emerald-600/20">
                  <SafeIcon icon={FiFileText} className="text-3xl" />
                </div>
                
                <h2 className="text-3xl font-bold text-stone-900 mb-6 italic">Vollständige Spezifikation anfragen</h2>
                <p className="text-stone-600 mb-10 leading-relaxed">
                  Unsere technischen Unterlagen stellen wir nach Unterzeichnung einer Vertraulichkeitsvereinbarung (NDA) zur Verfügung. Dies umfasst CAD-Daten, detaillierte Sensor-Spezifikationen und Software-Dokumentationen.
                </p>

                <div className="space-y-8">
                  <div className="flex items-start gap-4 p-6 bg-white rounded-2xl border border-stone-200 shadow-sm">
                    <div className="mt-1">
                      <SafeIcon icon={FiLock} className="text-emerald-600" />
                    </div>
                    <div>
                      <h4 className="font-bold text-stone-900 text-sm mb-1">NDA-Prozess</h4>
                      <p className="text-xs text-stone-500">Ihre Daten werden vertraulich behandelt und nur zur Prüfung der Berechtigung genutzt.</p>
                    </div>
                  </div>

                  <button 
                    onClick={() => document.getElementById('nda-form')?.scrollIntoView({ behavior: 'smooth' })}
                    className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-5 rounded-xl transition-all flex items-center justify-center gap-3 shadow-xl shadow-emerald-600/20"
                  >
                    NDA anfordern
                  </button>
                </div>
              </div>
            </motion.div>

          </div>
        </div>
      </section>

      {/* Info Footer */}
      <section className="py-12 bg-stone-900">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8 opacity-60">
            <div className="flex items-center gap-3 text-white">
              <SafeIcon icon={FiMapPin} className="text-emerald-400" />
              <span className="text-sm font-medium">CoreUnit Systems Hub, Westerstede / A28</span>
            </div>
            <div className="flex items-center gap-3 text-white">
              <SafeIcon icon={FiMail} className="text-emerald-400" />
              <span className="text-sm font-medium">info@coreunit-systems.de</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;